import { render, staticRenderFns } from "./EdSoroushplusDestination.vue?vue&type=template&id=83f72728&"
import script from "./EdSoroushplusDestination.vue?vue&type=script&lang=js&"
export * from "./EdSoroushplusDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports